import React, {ReactNode} from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(theme => ({
	root: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	one: {
		flexGrow: 0,
	},
	two: {
		flexGrow: 1,
		padding: theme.spacing(1),
		whiteSpace: 'pre-line',
	},
}), {name: 'ToastIconComponent'});

interface ErrorToastComponentProps {
	icon: ReactNode
	content: ReactNode
	name?: string // required for queue
}

export function ToastIconComponent({icon, content}: ErrorToastComponentProps) {
	const classes = useStyles();
	return (
		<div className={classes.root}>
			<div className={classes.one}>
				{icon}
			</div>
			<div className={classes.two}>
				{content}
			</div>
		</div>
	)
}